import React from 'react';

import MeetingContactAvatar from 'flow/components/meeting/shared/MeetingContactAvatar';
import { MeetingMember } from 'flow/types/Meeting';
import { TypedMap } from 'flow/types/TypedMap';

interface Props {
    member: TypedMap<MeetingMember>;
}

const MeetingLobbyOngoingAvatar = ({ member }: Props) => (
    <MeetingContactAvatar
        chatUserKey={member.getIn(['identity', 'chatUserKey'])}
        phoneNumber={member.get('number')}
        displayName={member.get('displayName')}
        embeddedContact={member.get('contact')}
        size="small"
    />
);

export default MeetingLobbyOngoingAvatar;
